import { findingsQueryOptions } from '../../../hooks/data/useFindings'
import { queryClient } from '../../../queryClient'

export async function unresolvedFindings(dataCollectionStatementId, namespace) {
  try {
    // fetchQuery, not ensureQueryData: once a finding mutation invalidates the entry, the count must be re-read.
    const findingsToResolve = await queryClient.fetchQuery({
      ...findingsQueryOptions({ dcsId: dataCollectionStatementId, namespace, resolved: false }),
      meta: { suppressGlobalError: true },
    })
    const findingsToResolveCount = findingsToResolve?.length ?? 0

    return {
      disabled: false,
      totalError: findingsToResolveCount,
      error: findingsToResolveCount ? 'Existen observaciones a resolver' : '',
    }
  } catch {
    // The finding flag is not required, so if there is an error loading it, we ignore to load form data
    return {
      disabled: false,
      totalError: 0,
      error: '',
    }
  }
}
